import React, { useEffect, useState } from "react"
import { useIsMutating } from "@tanstack/react-query"
import { ListaUsuarios } from '../../../components/Suporte/CadastroUsuario/components/usuarios'
import { FormCadastroUsuario } from '../../../components/Suporte/CadastroUsuario/components/form-cadastro'
import { useUsuario } from "../../../context/Suporte/CadastroUsuarioContext"
import { ModalSucesso } from "../../../components/Modal/components/sucesso"
import { ModalErro } from "../../../components/Modal/components/erro"
import { GenericModal } from "../../../components/Modal"
import { useModal } from "../../../hooks/ModalContext"
import { Loader } from "../../../components/generics/loader"



export const CadastroUsuario = () => {
  const { getPerfils, getCredores, getUsuario } = useUsuario()
  const { modalInfo, onClose } = useModal()

  const isMutation = useIsMutating({ mutationKey: ['usuario'] })

  useEffect(() => {
    getUsuario()
    getPerfils()
    getCredores()
  }, [])

  const [aba, setAba] = useState('Usuários')
  // const selecionada = ''
  return (
    <section>
      <div className="m-4 ml-20 mt-10 flex max-h-max flex-grow  flex-col overflow-y-auto ">
        <div className="flex items-center gap-2">
          <div className="flex items-start ">
            <button className={`aba-operador w-30  ${aba === 'Usuários' ? 'bg-slate-200' : 'bg-slate-100'}`} onClick={() => setAba('Usuários')}>Usuários</button>
          </div>
          <div className="flex items-start ">
            <button className={`aba-operador w-30  ${aba === 'Cadastrar' ? 'bg-slate-200' : 'bg-slate-100'}`} onClick={() => setAba('Cadastrar')}>Cadastrar</button>
          </div>
        </div>

        <div className="mb-2 flex h-[85vh] w-[94%] items-center justify-center gap-2 rounded-lg border-2 bg-slate-200 px-2 py-2">

          {aba === 'Usuários' && <ListaUsuarios />}
          {aba === 'Cadastrar' && <FormCadastroUsuario setAba={setAba} />}

          <ModalSucesso />
          <ModalErro />


          <GenericModal
            title={modalInfo.title}
            type={modalInfo.type}
            onClose={() => onClose()}
            show={modalInfo.isOpen && modalInfo.title === 'Atualiza Usuario'}
            modalType="Atualiza Usuario"
          />

        </div>
        {isMutation > 0 ? <div className={` flex justify-center items-center min-h-[80%]  w-[85%]  absolute m bg-white opacity-90  z-50 px-4 py-4`}>
          <Loader size={3.5} />
        </div> : <></>}
      </div>
    </section>
  )
}  